import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { BrandMark } from "@/components/site/Navbar";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-white/10 bg-[color:var(--sw-bg)]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-6">
          <div className="flex items-center gap-3">
            <BrandMark size={44} />
            <div className="leading-tight">
              <div className="display text-xl text-white">{t.brand.name}</div>
              <div className="text-[11px] uppercase tracking-[0.3em] text-white/50 mt-1">Smart Way International</div>
            </div>
          </div>
          <p className="text-white/60 max-w-md">{t.footer.about}</p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-6">{t.footer.quickLinks}</div>
          <ul className="space-y-3">
            {[
              { to: "/", l: t.nav.home },
              { to: "/about", l: t.nav.about },
              { to: "/services", l: t.nav.services },
              { to: "/services/foreign-investment", l: t.nav.foreign },
              { to: "/services/licensing", l: t.nav.licensing },
              { to: "/contact", l: t.nav.contact },
            ].map((x) => (
              <li key={x.to}>
                <Link to={x.to} className="edit-link text-white/80 hover:text-[color:var(--sw-orange)] transition-colors">{x.l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4 space-y-4">
          <div className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-4">{t.footer.contact}</div>
          <a href="tel:+966590960314" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/85 hover:text-[color:var(--sw-orange)] transition-colors" data-testid="footer-call1">
            <Phone size={16}/> 0590960314
          </a>
          <a href="tel:+966567522149" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/85 hover:text-[color:var(--sw-orange)] transition-colors" data-testid="footer-call2">
            <Phone size={16}/> 0567522149
          </a>
          <a href="https://wa.me/966590960314" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/85 hover:text-[color:var(--sw-orange)] transition-colors" data-testid="footer-whatsapp">
            <MessageCircle size={16}/> WhatsApp 0590960314
          </a>
          <a href="mailto:info@smartwayinsa.com" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/85 hover:text-[color:var(--sw-orange)] transition-colors" data-testid="footer-email">
            <Mail size={16}/> info@smartwayinsa.com
          </a>
        </div>
      </div>

      <div className="sw-rule mx-6 md:mx-10" />

      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] uppercase tracking-[0.24em] text-white/50">
        <div>© 2026 Smart Way International — {t.footer.allRights}</div>
        <a
          href="https://www.artlenss.com"
          target="_blank"
          rel="noreferrer"
          className="edit-link text-white/70 hover:text-[color:var(--sw-orange)] transition-colors"
          data-testid="artlens-credit"
        >
          {t.footer.rights}
        </a>
      </div>
    </footer>
  );
};

export default Footer;
